import type {
  BaseErrorResponse,
  CreateLanguageReq,
  GetLanguageRes,
  GetLanguagesRes,
  UpdateLanguageReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useLanguage() {
  class Language<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Language
     * @name languageControllerGetLanguages
     * @summary Getting a list of languages
     * @request GET:/api3/language
     * @secure
     * @response `200` `GetLanguagesRes`
     * @response `400` `BaseErrorResponse`
     */
    languageControllerGetLanguages = (params: RequestParams = {}) =>
      this.request<GetLanguagesRes, BaseErrorResponse>({
        path: '/api3/language',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Language
     * @name LanguageControllerCreateLanguage
     * @summary Creating a language
     * @request POST:/api3/language
     * @secure
     * @response `200` `GetLanguageRes`
     * @response `400` `BaseErrorResponse`
     */
    languageControllerCreateLanguage = (data: CreateLanguageReq, params: RequestParams = {}) =>
      this.request<GetLanguageRes, BaseErrorResponse>({
        path: '/api3/language',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Language
     * @name LanguageControllerUpdateLanguage
     * @summary Updating a language
     * @request PUT:/api3/language/{id}
     * @secure
     * @response `200` `GetLanguageRes`
     * @response `400` `BaseErrorResponse`
     */
    languageControllerUpdateLanguage = (id: string, data: UpdateLanguageReq, params: RequestParams = {}) =>
      this.request<GetLanguageRes, BaseErrorResponse>({
        path: `/api3/language/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Language
     * @name LanguageControllerDeleteLanguage
     * @summary Deleting a language
     * @request DELETE:/api3/language/{id}
     * @secure
     * @response `200` `GetLanguageRes`
     * @response `400` `BaseErrorResponse`
     */
    languageControllerDeleteLanguage = (id: string, params: RequestParams = {}) =>
      this.request<GetLanguageRes, BaseErrorResponse>({
        path: `/api3/language/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Language();
}
